<template>
    <div>
        <data-iterator
            ref="iterator"
            :api="api"
            :filters.sync="filters"
            :fixed-filters="{ company: { exact: company } }"
        >
            <template v-slot:actions>
                <slot name="actions"></slot>
            </template>

            <template slot-scope="{ items }">
                <d-table
                    :items="items"
                    :headers="headers"
                    :filters.sync="filters"
                    row-select
                    row-action
                    @onRowSelected="onRowSelected"
                >
                    <!-- restaurant column -->
                    <template v-slot:[`item.restaurant`]="{ item }">
                        <router-link :to="getEditLink(item)">
                            {{ item.restaurant ? item.restaurant.name : '' }}
                        </router-link>
                    </template>

                    <!-- allowed meals column -->
                    <template v-slot:[`item.mealCodes`]="{ item }">
                        <v-chip
                            v-if="
                                !item.mealCodes || item.mealCodes.length === 0
                            "
                            small
                        >
                            {{ $t('labels.all_meals') }}
                        </v-chip>
                        <span v-else>
                            {{
                                $tc(
                                    'labels.meals_count',
                                    item.mealCodes.length,
                                    {
                                        count: item.mealCodes.length,
                                    }
                                )
                            }}
                        </span>
                    </template>

                    <!-- row actions -->
                    <template v-slot:rowActions="{ item }">
                        <edit-button :to="getEditLink(item)"></edit-button>
                        <delete-action
                            :entity-name="
                                item.restaurant ? item.restaurant.name : ''
                            "
                            :entity-id="item.id"
                            :api="api"
                            @deleted="onEntityDeleted"
                            @failed="onEntityDeleteFailed"
                        ></delete-action>
                    </template>
                </d-table>
            </template>

            <!-- batch actions -->
            <template v-slot:batchActions>
                <delete-batch-action
                    :selected-ids="selectedIds"
                    :api="api"
                    @finished="onBatchDeleteFinished"
                    @finishedWithErrors="onBatchDeleteFinishedWithErrors"
                    @canceled="onBatchDeleteCanceled"
                ></delete-batch-action>
            </template>
        </data-iterator>
    </div>
</template>

<script>
import routeType from '@/router/routeType'
import RestApiType from '@/api/RestApiType'
import RestApiCollection from '@/api/RestApiCollection'
import DataIteratorMixin from '@/components/mixins/DataIteratorMixin'
import DataTableMixin from '@/components/mixins/DataTableMixin'
import AllowedMealsHeaders from '@/pages/companies/mixins/AllowedMealsHeaders'

export default {
    mixins: [DataIteratorMixin, DataTableMixin, AllowedMealsHeaders],
    props: {
        companyId: {
            type: [String, Number],
            required: true,
        },
    },
    data() {
        return {
            api: RestApiType.COMPANY_ALLOWED_MEALS,
            notiLabel: 'labels.allowed_meal',
        }
    },
    computed: {
        company() {
            return RestApiCollection.get(RestApiType.COMPANIES).getItemIri(
                this.companyId
            )
        },
    },
    methods: {
        getEditLink(item) {
            return {
                name: routeType.COMPANY_ALLOWED_MEAL_EDIT,
                params: { companyId: this.companyId, allowedMealId: item.id },
            }
        },
    },
}
</script>
